<template>
  <div ref="container" class="badge-3d" aria-label="可拖动旋转的 3D 徽章" />
</template>

<script setup>
import { defineEmits, defineProps, onBeforeUnmount, onMounted, ref } from "vue";
import { createSimpleBadgeViewer } from "@/utils/simple-badge-viewer";

const props = defineProps({
  modelBuffer: { type: ArrayBuffer, required: true },
});
const emit = defineEmits(["error"]);
const container = ref(null);
const viewer = createSimpleBadgeViewer(props.modelBuffer);

onMounted(() => {
  viewer.init(container.value, undefined, () => emit("error"));
});
onBeforeUnmount(() => viewer.dispose());
</script>

<style scoped>
.badge-3d {
  width: 100%;
  height: 100%;
  touch-action: pan-y;
}
</style>
